import React from 'react';

/* ─────────────────────────────────────────────────────────
 * RECOMMENDATION CARD
 * Agent suggestions with confidence meters, action buttons,
 * and highlight tags.
 * ───────────────────────────────────────────────────────── */

export default function RecommendationCard({
  title = "Reorder waffle cones from cone_king with lead time 7_days",
  confidence = 94,
  highlights = ["cone_king", "7_days", "1,500 units", "$420.00 total"],
  primaryAction = "Create Reorder Draft",
  secondaryAction = "View Vendor SLA",
  onPrimary,
  onSecondary,
}: {
  title?: string;
  confidence?: number;
  highlights?: string[];
  primaryAction?: string;
  secondaryAction?: string;
  onPrimary?: () => void;
  onSecondary?: () => void;
}) {
  return (
    <div className="flex flex-col gap-3 rounded-card bg-surface p-4 shadow-card border border-line my-2 w-full max-w-105">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-accent">
            <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3" />
          </svg>
          <span className="text-[13px] font-semibold text-ink">Agent Recommendation</span>
        </div>
        {confidence && (
          <div className="flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-green-tint text-green text-[11px] font-mono font-medium">
            <div className="w-8 h-1 bg-green/20 rounded-full overflow-hidden">
              <div className="h-full bg-green rounded-full" style={{ width: `${confidence}%` }} />
            </div>
            <span>{confidence}% Confidence</span>
          </div>
        )}
      </div>

      <div className="text-[13.5px] font-medium text-ink leading-relaxed">
        {title}
      </div>

      {highlights && highlights.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {highlights.map((h, i) => (
            <span key={i} className="font-mono text-[11px] px-2 py-0.5 rounded-chip bg-field text-accent font-medium shadow-hairline">
              {h}
            </span>
          ))}
        </div>
      )}

      <div className="flex items-center gap-2 pt-1">
        {primaryAction && (
          <button
            type="button"
            onClick={onPrimary}
            className="px-3 py-1.5 rounded-control bg-ink text-canvas text-xs font-semibold hover:opacity-90 transition-opacity active:scale-[0.96]"
          >
            {primaryAction}
          </button>
        )}
        {secondaryAction && (
          <button
            type="button"
            onClick={onSecondary}
            className="px-3 py-1.5 rounded-control bg-field hover:bg-hover text-xs text-ink-2 hover:text-ink transition-colors active:scale-[0.96]"
          >
            {secondaryAction}
          </button>
        )}
      </div>
    </div>
  );
}
